export const AMP_BASE_NAME = '/ui';

export const HNM_BRANDNAME = 'HNM';

export const CLIENT_NAME = 'hnm-flight';

export const APP_VERSION = process.env.APP_VERSION || window.APP_VERSION;
